import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { useAppContext } from 'hooks/useAppContext';

const useStyles = makeStyles(theme => ({
  menuButton: {
    marginRight: theme.spacing(2)
  }
}));


const DrawerButton = () => {
  const context = useAppContext();
  const { drawerOpen, updateDrawerStatus } = context;
  const classes = useStyles();

  const handleClick = event => {
    updateDrawerStatus(!drawerOpen);
  }

  return (
    <IconButton
      edge="start"
      className={classes.menuButton}
      color="inherit"
      aria-label="open drawer"
      onClick={ handleClick }
    >
     { !drawerOpen ? <MenuIcon /> : <CloseIcon /> }
    </IconButton>
  )
};

export default DrawerButton;